module.exports = __webpack_public_path__ + "static/HeroFinCorp-57d23d899992ab15d87d44d902ed7818.jpg";